<template>
	<svg id="Layer_1" class="a-check-bullet" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9 9">
	<defs>
		
	</defs>
		<g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1-2">
			<path class="cls-1" d="M8,4H9V8A1,1,0,0,1,8,9H1a1,1,0,0,1-.72-.29A1,1,0,0,1,0,8V1A1,1,0,0,1,1,0H6V1H1V8H8ZM4,5.09,8.3.8l.7.7-5,5L1.76,4.24l.7-.7Z" transform="translate(0 0)"/>
		</g>
		</g>
</svg>
</template>
<script>
export default {
	
}
</script>
<style lang="scss" scoped>
.a-check-bullet {
	width: 14px;
	margin: 5px;
}
.cls-1{
		fill:#636669;
	}
</style>
